import React from 'react';
import {Field} from 'redux-form';
import Row from "../Row";

const renderField = (field) => {
    const {input, label, meta, min = 0, max = 10, minLabel = '', maxLabel = '', disabled = false} = field;

    const values = [];
    for (let i = min; i <= max; i++) values.push(i);

    const currentValue = input.value;

    const handleSelect = (value) => {
        if (disabled) return;
        const stringValue = value.toString();
        if (currentValue === stringValue) {
            input.onChange(null);
        } else {
            input.onChange(stringValue);
        }
    };

    return (
        <Row {...field}>
            <div className="col-12 col-lg-4">
                <label htmlFor={input.name} className="m-0">{label}</label>
            </div>
            <div className="col-12 col-lg-8">
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                    fontSize: '0.85rem',
                    color: '#6c757d',
                    marginBottom: '6px',
                }}>
                    <span>{minLabel}</span>
                    <span>{maxLabel}</span>
                </div>
                <div style={{
                    display: 'flex',
                    width: '100%',
                    border: '1px solid #ced4da',
                    borderRadius: '4px',
                    overflow: 'hidden',
                }}>
                    {values.map((v, idx) => {
                        const stringValue = v.toString();
                        const isSelected = currentValue === stringValue;
                        return (
                            <button
                                type="button"
                                key={v}
                                disabled={disabled}
                                onClick={() => handleSelect(v)}
                                style={{
                                    flex: '1 1 0',
                                    minWidth: 0,
                                    padding: '12px 0',
                                    background: isSelected ? '#28a745' : '#fff',
                                    color: isSelected ? '#fff' : '#212529',
                                    border: 'none',
                                    borderLeft: idx === 0 ? 'none' : '2px solid #28a745',
                                    cursor: disabled ? 'not-allowed' : 'pointer',
                                    fontWeight: 600,
                                    fontSize: '1rem',
                                    textAlign: 'center',
                                    outline: 'none',
                                }}
                            >
                                {v}
                            </button>
                        );
                    })}
                </div>
            </div>
        </Row>
    );
};

const RatingScale = props => <Field {...props} component={renderField}/>;

export default RatingScale;
